import { createStyles, makeStyles } from '@material-ui/styles';
import { MessageView, LargeInfoCircle } from 'neon-design-system';

const useStyles = makeStyles(() =>
  createStyles({
    appError: {
      display: 'flex',
      height: '100%'
    },
    appErrorContainer: {
      '& > *': {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center'
      }
    }
  })
);

export const ServerErrorView = () => {
  const classes = useStyles();

  return (
    <div className={`${classes.appError} ${classes.appErrorContainer}`}>
      <MessageView
        styleName="primary"
        title="Please try again later"
        size="medium"
        icon={<LargeInfoCircle />}
        primaryAction={{
          label: 'Refresh',
          onClick: () => window.location.reload()
        }}
      >
        Support Center is unavailable right now.
      </MessageView>
    </div>
  );
};
